import React from "react";

function OrganizationTitle(props) {
  const { data } = props;
  return (
    <div className="card shadow-card">
      <div className="card-body">
        <h4 className="strong mb-2">
          {/* data && data.legacyUnifiedCustomerCode  /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
          {data && data.unifiedCustomerCode           /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
        </h4>
        <p>{data && data.customerNameLocalKana}</p>
        <h3 className="inner-title mb-1">
          {data && data.customerNameLocal}
          {data && data.ultmarcRecordId && data.ultmarcModificationType && (
            <span className="badge badge-primary ml-3">Ultmarc</span>
          )}
        </h3>
      </div>
    </div>
  );
}

export default OrganizationTitle;
